export const API_URL = 'https://prod.malllogisticsapi.com/api/';
export const HANDSFREE_URL = 'https://handsfreeapi.com/';
export const PAYMENT_API_URL = 'https://payment.easypointapi.com/';
